import { put, takeEvery, retry, call, select } from 'redux-saga/effects';
import { GET_NOTIFICATION_LIST_REQUEST, OPEN_ADVERTISEMENT_REQUEST } from '../actionConstants/advertisementConstants';
import { RETRY_DELAY, RETRY_MAX_TRIES } from '../../constants/apiConstant';
import { getNotificationList, updateNotificationReadStatus } from '../../api/generalApi';
import {
  getNotificationListSuccess,
  notificationLoadingEnd,
  openAdvertisementSuccess,
  resetNotification,
} from '../actions/advertisementActions';
import { checkIsWebApp } from '../../services';
import { doneRequestSequentialModal } from '../actions';
import { SEQUENTIAL_MODALS } from '../../constants/sequentialModals';
import { errorHandler } from './errorSaga';

function* getNotificationListRequestHandler() {
  try {
    // モーダルを開いている間は取得しない
    const isOpen = yield select((state) => state.advertisement.isOpen);
    if (isOpen) {
      return;
    }
    const {
      data: { list },
    } = yield retry(RETRY_MAX_TRIES, RETRY_DELAY, getNotificationList, { isWeb: checkIsWebApp() });
    yield put(getNotificationListSuccess({ advertisementsList: list }));
  } catch (e) {
    yield call(errorHandler, { error: e });
  } finally {
    yield put(notificationLoadingEnd());
  }
}

function* openAdvertisementRequestHandler() {
  try {
    const advertisementsList = yield select((state) => state.advertisement.advertisementsList);
    const maxShowCount = yield select((state) => state.sequentialModals.remainingModalCount);
    const limitedList = advertisementsList?.slice(0, maxShowCount) || [];
    if (!limitedList.length) {
      // 次にgetNotificationListRequestされるまでモーダルを出さない
      yield put(resetNotification());
      yield put(doneRequestSequentialModal({ modalId: SEQUENTIAL_MODALS.Advertisements }));
      return;
    }
    const advertisementInfo = limitedList.shift();
    // update advertisementsList after remove first element
    yield put(getNotificationListSuccess({ advertisementsList: limitedList }));

    yield put(openAdvertisementSuccess({ body: advertisementInfo.body, popupUrl: advertisementInfo.popupUrl }));

    yield call(updateNotificationReadStatus, { notificationId: advertisementInfo.id });
  } catch (e) {
    yield call(errorHandler, { error: e });
  }
}

export default function* advertisementSaga() {
  yield takeEvery(GET_NOTIFICATION_LIST_REQUEST, getNotificationListRequestHandler);
  yield takeEvery(OPEN_ADVERTISEMENT_REQUEST, openAdvertisementRequestHandler);
}
